// Translations
import landing from '../views/landing/translations/ar'

// Translation: Login (Arabic)
export default Object.freeze({
	name: 'تسجيل الدخول',
	views: { landing }
})
